import { render, staticRenderFns } from "./AvatarStoreItem.vue?vue&type=template&id=4882f32c&"
import script from "./AvatarStoreItem.vue?vue&type=script&lang=js&"
export * from "./AvatarStoreItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports